import { createApi } from '@reduxjs/toolkit/query/react';

import { apiClientInvoiceStatuses } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { ClientInvoiceStatus, ClientInvoiceStatusTransition } from '~lookups/models';

export const clientInvoiceStatusesApi = createApi({
  reducerPath: 'clientInvoiceStatusesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiClientInvoiceStatuses }),
  tagTypes: ['client-invoice-statuses', 'client-invoice-statuses/transitions'],
  endpoints: (builder) => ({
    getClientInvoiceStatuses: builder.query<ClientInvoiceStatus[], Request | void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'client-invoice-statuses', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ClientInvoiceStatus[]>(payload),
    }),
    getClientInvoiceStatusTransitions: builder.query<ClientInvoiceStatusTransition[], Request | void>({
      query: () => ({ url: '/transitions', method: 'GET' }),
      providesTags: [{ type: 'client-invoice-statuses/transitions', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ClientInvoiceStatusTransition[]>(payload),
    }),
  }),
});

export const { useGetClientInvoiceStatusesQuery, useGetClientInvoiceStatusTransitionsQuery } = clientInvoiceStatusesApi;
